@if (isShowRemindMeLaterNotification) {
    <bs-remind-me-later-notification (closeTokensReminder)="closeReminder()" (undoTokensReminder)="undoReminder()"> </bs-remind-me-later-notification>
} @else {
    @if (hasTokens && !isBannerDismissed) {
        @if (!isExpandableBannerEnabled) {
            <a class="reward-tokens-banner__promo-link" [href]="promotionsUrl">
                <span class="reward-tokens-banner__action"> <i class="theme-right"></i> </span>
                <div class="reward-tokens-banner__center-wrapper" [ngClass]="{ isRightCol: layoutManager.layout.isRightVisible }">
                    @if (viewData.icon) {
                        <div class="reward-tokens-banner__icon">
                            <span [class]="viewData.icon"></span>
                        </div>
                    }
                    <div
                        class="reward-tokens-banner__content--two-titles"
                        [ngClass]="{ 'reward-tokens-banner__content': layoutManager.layout.isRightVisible }">
                        <div class="reward-tokens-banner__title">{{ viewData.title }}</div>
                        <div class="reward-tokens-banner__subtitle">{{ this.sitecore.crmTokens.banner.BannerSubtitle }}</div>
                    </div>
                </div>
            </a>
        } @else {
            <div class="banner-header" (click)="toggleBannerExpansion()">
                <div class="banner-title">
                    @if (viewData.icon) {
                        <i class="banner-icon {{ viewData.icon }}"></i>
                    }
                    {{ viewData.title }}
                </div>
                @if (isRewardDrawerEnabled) {
                    <div class="banner-header-hide" [ngClass]="{ 'no-dismiss-link': !messagesAndConfigs.showDismissLink }">
                        @if (messagesAndConfigs.showDismissLink) {
                            <span (click)="hideBanner($event)">{{ messagesAndConfigs.dismissLinkText }}</span>
                        }
                    </div>
                    <span class="banner-pipe"></span>
                }
                <i class="theme-down"></i>
            </div>
            @if (this.isBannerExpanded) {
                <bs-reward-tokens-list
                    class="banner-body"
                    [tokenInfos]="tokenInfos"
                    [isRewardDrawerEnabled]="isRewardDrawerEnabled"
                    (rewardBannerDismiss)="hideBanner($event)"></bs-reward-tokens-list>
            }
        }
    }

    @if (isPromoRestricted) {
        <div class="reward-tokens-banner__promo-restricted">
            <span class="reward-tokens-banner__info-icon">
                <i class="theme-info-i"></i>
            </span>
            <div class="reward-tokens-banner__restricted-message" [innerHTML]="promoRestrictedMessage"></div>
        </div>
    }
}
